import { Button } from "components/DesignSystem/Button/Button";
import { CaretLeft } from "components/icons/CaretLeft";
import { ReactNode } from "react";

type InvoiceEditorHeaderProps = {
  title: ReactNode;
  status: ReactNode;
  onBackClick?: () => void;
  right?: ReactNode;
};

export const InvoiceEditorHeader = ({
  title,
  status,
  onBackClick,
  right,
}: InvoiceEditorHeaderProps) => (
  <div className="t-flex t-flex-col t-gap-2 sm:t-flex-row sm:t-flex-wrap sm:t-items-center sm:t-gap-1">
    {onBackClick && (
      <Button
        type="button"
        customType="link_neutral"
        className="!t-text-subtext !t-leading-5"
        onClick={onBackClick}
      >
        <span className="t-flex t-items-center t-gap-1">
          <span className="t-flex t-p-0.5">
            <CaretLeft />
          </span>
          <span className="sm:t-hidden">Back</span>
        </span>
      </Button>
    )}
    <div className="t-flex t-items-center t-gap-3 sm:t-contents">
      <h5 className="t-m-0 t-text-title-h2-bold t-leading-normal t-tracking-[0.15px] t-text-text-100">
        {title}
      </h5>
      {status}
      {right && (
        <div className="t-ml-auto sm:t-order-last sm:t-ml-0 sm:t-basis-full sm:t-pl-7">
          {right}
        </div>
      )}
    </div>
  </div>
);
